<template>
  <UiContainer tag="section">
    <ul class="flex flex-wrap gap-2">
      <li v-for="button in sections" :key="'button' + button.id">
        <UiButton
          severity="tertiary"
          :active="activeSection === button.id"
          class="px-5 py-2.5 text-sm"
          @click="
            () => {
              emit('update:activeSection', button.id)
              emit('update:showAll', false)
            }
          "
        >
          {{ button.title }}
        </UiButton>
      </li>
      <li v-if="!showAllSections">
        <UiButton
          class="flex items-center px-5 py-2.5 text-sm"
          severity="tertiary"
          @click="emit('update:showAllSections', true)"
        >
          Другие вопросы?
        </UiButton>
      </li>
      <li v-else>
        <UiButton
          severity="tertiary"
          class="flex items-center px-5 py-2.5 text-sm"
          :active="showAll"
          @click="
            () => {
              emit('update:showAll', true)
              emit('update:activeSection', undefined)
            }
          "
        >
          Хочу посмотреть все ответы на вопросы
        </UiButton>
      </li>
    </ul>
  </UiContainer>
</template>

<script setup lang="ts">
import type { FAQ } from '@/5_entities/FAQ'
import { UiButton, UiContainer } from '@/6_shared/ui'

type PropType = {
  sections: Pick<FAQ, 'id' | 'title'>[]
  activeSection?: number
  showAllSections: boolean
  showAll: boolean
}
type EmitType = {
  (e: 'update:showAllSections', value: boolean): void
  (e: 'update:activeSection', value?: number): void
  (e: 'update:showAll', value: boolean): void
}

defineProps<PropType>()
const emit = defineEmits<EmitType>()
</script>
